import { render, staticRenderFns } from "./CollapsibleBlock.vue?vue&type=template&id=270aea7b&"
import script from "./CollapsibleBlock.js?vue&type=script&lang=js&"
export * from "./CollapsibleBlock.js?vue&type=script&lang=js&"
import style0 from "./CollapsibleBlock.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports